var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Proposals",
    transform: "translate(-452.000000, -1043.000000)",
    fill: "#00B46E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(259.000000, 729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-event"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.430565,326 C198.17501,326 197.919233,325.898923 197.7239,325.696307 L193.293471,321.102142 C192.902584,320.69691 192.90214,320.039447 193.29236,319.633523 C193.682581,319.22783 194.315912,319.227369 194.706578,319.6326 L198.430565,323.494071 L207.293422,314.303895 C207.684088,313.898202 208.317197,313.898894 208.70764,314.304818 C209.09786,314.710742 209.097416,315.368205 208.706529,315.773437 L199.137229,325.696307 C198.941896,325.898923 198.686119,326 198.430565,326",
    id: "icon-checkmark"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.5cdde988.svg";
export { ForwardRef as ReactComponent };